module.exports = __webpack_public_path__ + "img/wechat.845b0415.png";